import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiRoutes } from 'consts';
import { apiErrorHandler } from 'services/apiErrorHandler';
import { showErrorNotification } from 'utils/notification';
import { ThunkConfig } from 'app/providers/StoreProvider';
import { getStockOrderProductListSearch } from '../selectors/stockOrderEditSelectors';

export const getProductList = createAsyncThunk<
  any[],
  void,
  ThunkConfig<string>
>('stock/getProductList', async (_, thunkApi) => {
  const {
    extra: { api },
    getState,
  } = thunkApi;
  try {

    const search = getStockOrderProductListSearch(getState());

    const { data } = await api.get(ApiRoutes.Product, {
      params: { page: 0, size: 10, search },
    });    

    return data;
  } catch (error) {
    const { message } = apiErrorHandler(error);
    showErrorNotification([message]);
    // Важно возвращать явно undefined, если функция должна завершиться после ошибки
    return undefined;
  }
});
